var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-column" },
    [
      _vm.$_can("jobs.system.logs.index")
        ? _c(
            "div",
            { staticClass: "d-flex align-items-center justify-content-end" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-change",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.showSystemLogs = !_vm.showSystemLogs
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.showSystemLogs
                          ? "Back to regular logs"
                          : "View system logs"
                      ) +
                      "\n    "
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showSystemLogs && _vm.$_can("jobs.system.logs.index")
        ? [_c("log", { attrs: { model: _vm.job, type: "jobs" } })]
        : [
            !_vm.logs
              ? [
                  _c(
                    "vue-content-loading",
                    { attrs: { width: 800, height: 450 } },
                    _vm._l(15, function(x) {
                      return _c("rect", {
                        key: x,
                        attrs: {
                          x: "10",
                          y: 15 * x * 1.4,
                          rx: "5",
                          ry: "5",
                          width: "720",
                          height: "6"
                        }
                      })
                    })
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            [
              _c(
                "div",
                { staticClass: "log-wrap mb-3", attrs: { id: "accordion" } },
                _vm._l(_vm.logs, function(log) {
                  return _c(
                    "div",
                    { key: log.id },
                    [
                      log.type === "job_created"
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row align-items-center log-box collapsed",
                                attrs: {
                                  id: "heading-" + log.id,
                                  "data-toggle": "collapse",
                                  "data-parent": "#accordion",
                                  "data-target": "#collapse-" + log.id,
                                  "aria-controls": "#collapse-" + log.id
                                }
                              },
                              [
                                _vm._m(0, true),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-11 d-flex align-items-center justify-content-between flex-row"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "log-description" },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-0 log-description"
                                          },
                                          [_vm._v("Move booked")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "mb-0 log-date" },
                                          [
                                            _vm._v(
                                              _vm._s(log.created_at) +
                                                " | " +
                                                _vm._s(log.done_by)
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(1, true)
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "collapse",
                                attrs: {
                                  id: "collapse-" + log.id,
                                  "aria-expanded": "false",
                                  "data-parent": "#accordion"
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", {
                                    staticClass:
                                      "col-1 d-none d-lg-block d-xl-block d-md-block"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-11 pt-3" }, [
                                    _c(
                                      "table",
                                      {
                                        staticClass:
                                          "table m-table table-hover log-table"
                                      },
                                      [
                                        _c("tbody", [
                                          _c("tr", [
                                            _c("td", [_vm._v("Move date:")]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(log.data.move_date))
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [_vm._v("Movers:")]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(log.data.movers))
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [_vm._v("Trucks:")]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(log.data.trucks))
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [_vm._v("Move size:")]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(log.data.move_size))
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _vm._v("Arrival window:")
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(log.data.arrival_window)
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [
                                              _vm._v("Cash discount:")
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(log.data.cash_discount)
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [_vm._v("Min horus:")]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(log.data.minimum_hours)
                                              )
                                            ])
                                          ]),
                                          _vm._v(" "),
                                          _c("tr", [
                                            _c("td", [_vm._v("Deposit:")]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(_vm._s(log.data.deposit))
                                            ])
                                          ])
                                        ])
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      log.type === "job_updated"
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row align-items-center log-box collapsed",
                                attrs: {
                                  id: "heading-" + log.id,
                                  "data-toggle": "collapse",
                                  "data-parent": "#accordion",
                                  "data-target": "#collapse-" + log.id,
                                  "aria-controls": "#collapse-" + log.id
                                }
                              },
                              [
                                _vm._m(2, true),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-11 d-flex align-items-center justify-content-between flex-row"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "log-description" },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-0 log-description"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.getJobUpdatedTitle(log)
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "mb-0 log-date" },
                                          [
                                            _vm._v(
                                              _vm._s(log.created_at) +
                                                " | " +
                                                _vm._s(log.done_by)
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(3, true)
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "collapse",
                                attrs: {
                                  id: "collapse-" + log.id,
                                  "aria-expanded": "false",
                                  "data-parent": "#accordion"
                                }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", {
                                    staticClass:
                                      "col-1 d-none d-lg-block d-xl-block d-md-block"
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-11 pt-3" }, [
                                    _c(
                                      "table",
                                      {
                                        staticClass:
                                          "table m-table table-hover log-table"
                                      },
                                      [
                                        _vm._m(4, true),
                                        _vm._v(" "),
                                        _c("tbody", [
                                          log.data.old_move_date ||
                                          log.data.new_move_date
                                            ? _c("tr", [
                                                _c("td", [
                                                  _vm._v("Move date:")
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      log.data.old_move_date
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      log.data.new_move_date
                                                    )
                                                  )
                                                ])
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          log.data.new_movers ||
                                          log.data.old_movers
                                            ? _c("tr", [
                                                _c("td", [_vm._v("Movers:")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(log.data.old_movers)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(log.data.new_movers)
                                                  )
                                                ])
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          log.data.old_trucks ||
                                          log.data.new_trucks
                                            ? _c("tr", [
                                                _c("td", [_vm._v("Trucks:")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(log.data.old_trucks)
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(log.data.new_trucks)
                                                  )
                                                ])
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          log.data.old_move_size ||
                                          log.data.new_move_size
                                            ? _c("tr", [
                                                _c("td", [
                                                  _vm._v("Move size:")
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      log.data.old_move_size
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      log.data.new_move_size
                                                    )
                                                  )
                                                ])
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          log.data.old_arrival_window ||
                                          log.data.new_arrival_window
                                            ? _c("tr", [
                                                _c("td", [
                                                  _vm._v("Arrival window:")
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      log.data
                                                        .old_arrival_window
                                                    )
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    _vm._s(
                                                      log.data
                                                        .new_arrival_window
                                                    )
                                                  )
                                                ])
                                              ])
                                            : _vm._e()
                                        ])
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            )
                          ]
                        : log.type === "offer_created"
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row align-items-center log-box collapsed",
                                  attrs: {
                                    id: "heading-" + log.id,
                                    "data-toggle": "collapse",
                                    "data-parent": "#accordion",
                                    "data-target": "#collapse-" + log.id,
                                    "aria-controls": "#collapse-" + log.id
                                  }
                                },
                                [
                                  _vm._m(5, true),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-11 d-flex align-items-center justify-content-between flex-row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "log-description" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mb-0 log-description"
                                            },
                                            [
                                              _vm._v(
                                                "Custom rate created for the move " +
                                                  _vm._s(log.data.ref)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "mb-0 log-date" },
                                            [
                                              _vm._v(
                                                _vm._s(log.created_at) +
                                                  " | " +
                                                  _vm._s(log.done_by)
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._m(6, true)
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "collapse",
                                  attrs: {
                                    id: "collapse-" + log.id,
                                    "aria-expanded": "false",
                                    "aria-labelledby": "heading-" + log.id,
                                    "data-parent": "#accordion"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", {
                                      staticClass:
                                        "col-1 d-none d-lg-block d-xl-block d-md-block"
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-11 pt-3" }, [
                                      _c(
                                        "table",
                                        {
                                          staticClass:
                                            "table m-table table-hover log-table"
                                        },
                                        [
                                          _c("tbody", [
                                            _c("tr", [
                                              _c("td", [_vm._v("Move date:")]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(log.data.move_date)
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c("td", [_vm._v("Movers:")]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(log.data.movers))
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c("td", [_vm._v("Trucks:")]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(log.data.trucks))
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c("td", [_vm._v("Rate:")]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(log.data.rate))
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c("td", [_vm._v("Deposit:")]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(log.data.deposit))
                                              ])
                                            ])
                                          ])
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]
                          : log.type === "offer_updated"
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row align-items-center log-box collapsed",
                                    attrs: {
                                      id: "heading-" + log.id,
                                      "data-toggle": "collapse",
                                      "data-parent": "#accordion",
                                      "data-target": "#collapse-" + log.id,
                                      "aria-controls": "#collapse-" + log.id
                                    }
                                  },
                                  [
                                    _vm._m(7, true),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-11 d-flex align-items-center justify-content-between flex-row"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "log-description" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "mb-0 log-description"
                                              },
                                              [
                                                _vm._v(
                                                  "Custom rate saved for the move " +
                                                    _vm._s(log.data.ref)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              { staticClass: "mb-0 log-date" },
                                              [
                                                _vm._v(
                                                  _vm._s(log.created_at) +
                                                    " | " +
                                                    _vm._s(log.done_by)
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(8, true)
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "collapse",
                                    attrs: {
                                      id: "collapse-" + log.id,
                                      "aria-expanded": "false",
                                      "aria-labelledby": "heading-" + log.id,
                                      "data-parent": "#accordion"
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "row" }, [
                                      _c("div", {
                                        staticClass:
                                          "col-1 d-none d-lg-block d-xl-block d-md-block"
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-11 pt-3" },
                                        [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table m-table table-hover log-table"
                                            },
                                            [
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v("Move date:")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(log.data.move_date)
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c("td", [_vm._v("Movers:")]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(log.data.movers)
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c("td", [_vm._v("Trucks:")]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(log.data.trucks)
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c("td", [_vm._v("Rate:")]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(log.data.rate)
                                                    )
                                                  ])
                                                ]),
                                                _vm._v(" "),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v("Deposit:")
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(log.data.deposit)
                                                    )
                                                  ])
                                                ])
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            : log.type === "offer_deleted"
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row align-items-center log-box collapsed",
                                      attrs: {
                                        id: "heading-" + log.id,
                                        "data-toggle": "collapse",
                                        "data-parent": "#accordion",
                                        "data-target": "#collapse-" + log.id,
                                        "aria-controls": "#collapse-" + log.id
                                      }
                                    },
                                    [
                                      _vm._m(9, true),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-11 d-flex align-items-center justify-content-between flex-row"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "log-description" },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "mb-0 log-description"
                                                },
                                                [
                                                  _vm._v(
                                                    "Offer deleted for the move " +
                                                      _vm._s(log.data.ref)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass: "mb-0 log-date"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(log.created_at) +
                                                      " | " +
                                                      _vm._s(log.done_by)
                                                  )
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm._m(10, true)
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "collapse",
                                      attrs: {
                                        id: "collapse-" + log.id,
                                        "aria-expanded": "false",
                                        "aria-labelledby": "heading-" + log.id,
                                        "data-parent": "#accordion"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c("div", {
                                          staticClass:
                                            "col-1 d-none d-lg-block d-xl-block d-md-block"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-11 pt-3" },
                                          [
                                            _c(
                                              "table",
                                              {
                                                staticClass:
                                                  "table m-table table-hover log-table"
                                              },
                                              [
                                                _c("tbody", [
                                                  _c("tr", [
                                                    _c("td", [
                                                      _vm._v("Move date:")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(
                                                          log.data.move_date
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("tr", [
                                                    _c("td", [
                                                      _vm._v("Movers:")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(log.data.movers)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("tr", [
                                                    _c("td", [
                                                      _vm._v("Trucks:")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(log.data.trucks)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("tr", [
                                                    _c("td", [_vm._v("Rate:")]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(log.data.rate)
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("tr", [
                                                    _c("td", [
                                                      _vm._v("Deposit:")
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(log.data.deposit)
                                                      )
                                                    ])
                                                  ])
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              : log.type === "expense_created"
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "row align-items-center log-box collapsed",
                                        attrs: {
                                          id: "heading-" + log.id,
                                          "data-toggle": "collapse",
                                          "data-parent": "#accordion",
                                          "data-target": "#collapse-" + log.id,
                                          "aria-controls": "#collapse-" + log.id
                                        }
                                      },
                                      [
                                        _vm._m(11, true),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-11 d-flex align-items-center justify-content-between flex-row"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "log-description"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "mb-0 log-description"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(log.data.name) +
                                                        " of $" +
                                                        _vm._s(
                                                          log.data.amount
                                                        ) +
                                                        " added"
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass: "mb-0 log-date"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(log.created_at) +
                                                        " | " +
                                                        _vm._s(log.done_by)
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(12, true)
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "collapse",
                                        attrs: {
                                          id: "collapse-" + log.id,
                                          "aria-expanded": "false",
                                          "aria-labelledby":
                                            "heading-" + log.id,
                                          "data-parent": "#accordion"
                                        }
                                      },
                                      [
                                        _c("div", { staticClass: "row" }, [
                                          _c("div", {
                                            staticClass:
                                              "col-1 d-none d-lg-block d-xl-block d-md-block"
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-11 pt-3" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass:
                                                    "table m-table table-hover log-table"
                                                },
                                                [
                                                  _c("tbody", [
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v("Name:")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(log.data.name)
                                                        )
                                                      ])
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _vm._v("Amount:")
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          "$ " +
                                                            _vm._s(
                                                              log.data.amount
                                                            )
                                                        )
                                                      ])
                                                    ])
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                : log.type === "expense_updated"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "row align-items-center log-box collapsed",
                                          attrs: {
                                            id: "heading-" + log.id,
                                            "data-toggle": "collapse",
                                            "data-parent": "#accordion",
                                            "data-target":
                                              "#collapse-" + log.id,
                                            "aria-controls":
                                              "#collapse-" + log.id
                                          }
                                        },
                                        [
                                          _vm._m(13, true),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-11 d-flex align-items-center justify-content-between flex-row"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "log-description"
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "mb-0 log-description"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(log.data.name) +
                                                          " of $" +
                                                          _vm._s(
                                                            log.data.amount
                                                          ) +
                                                          " updated"
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "mb-0 log-date"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(log.created_at) +
                                                          " | " +
                                                          _vm._s(log.done_by)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._m(14, true)
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "collapse",
                                          attrs: {
                                            id: "collapse-" + log.id,
                                            "aria-expanded": "false",
                                            "aria-labelledby":
                                              "heading-" + log.id,
                                            "data-parent": "#accordion"
                                          }
                                        },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c("div", {
                                              staticClass:
                                                "col-1 d-none d-lg-block d-xl-block d-md-block"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-11 pt-3" },
                                              [
                                                _c(
                                                  "table",
                                                  {
                                                    staticClass:
                                                      "table m-table table-hover log-table"
                                                  },
                                                  [
                                                    _vm._m(15, true),
                                                    _vm._v(" "),
                                                    _c("tbody", [
                                                      log.data.old_amount ||
                                                      log.data.new_amount
                                                        ? _c("tr", [
                                                            _c("td", [
                                                              _vm._v("Amount:")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  log.data
                                                                    .old_amount
                                                                    ? "$ " +
                                                                      log.data
                                                                        .old_amount
                                                                    : ""
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  log.data
                                                                    .new_amount
                                                                    ? "$ " +
                                                                      log.data
                                                                        .new_amount
                                                                    : ""
                                                                )
                                                              )
                                                            ])
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      log.data.old_name ||
                                                      log.data.new_name
                                                        ? _c("tr", [
                                                            _c("td", [
                                                              _vm._v("Name:")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  log.data
                                                                    .old_name
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  log.data
                                                                    .new_name
                                                                )
                                                              )
                                                            ])
                                                          ])
                                                        : _vm._e()
                                                    ])
                                                  ]
                                                )
                                              ]
                                            )
                                          ])
                                        ]
                                      )
                                    ]
                                  : log.type === "discount_created"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row align-items-center log-box collapsed",
                                            attrs: {
                                              id: "heading-" + log.id,
                                              "data-toggle": "collapse",
                                              "data-parent": "#accordion",
                                              "data-target":
                                                "#collapse-" + log.id,
                                              "aria-controls":
                                                "#collapse-" + log.id
                                            }
                                          },
                                          [
                                            _vm._m(16, true),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-11 d-flex align-items-center justify-content-between flex-row"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "log-description"
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mb-0 log-description"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Discount of " +
                                                            _vm._s(
                                                              log.data.amount
                                                            ) +
                                                            " added"
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "mb-0 log-date"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            log.created_at
                                                          ) +
                                                            " | " +
                                                            _vm._s(log.done_by)
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._m(17, true)
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "collapse",
                                            attrs: {
                                              id: "collapse-" + log.id,
                                              "aria-expanded": "false",
                                              "aria-labelledby":
                                                "heading-" + log.id,
                                              "data-parent": "#accordion"
                                            }
                                          },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _c("div", {
                                                staticClass:
                                                  "col-1 d-none d-lg-block d-xl-block d-md-block"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-11 pt-3" },
                                                [
                                                  _c(
                                                    "table",
                                                    {
                                                      staticClass:
                                                        "table m-table table-hover log-table"
                                                    },
                                                    [
                                                      _c("tbody", [
                                                        _c("tr", [
                                                          _c("td", [
                                                            _vm._v("Name:")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                log.data.name
                                                              )
                                                            )
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("tr", [
                                                          _c("td", [
                                                            _vm._v("Amount:")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                log.data.amount
                                                              )
                                                            )
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("tr", [
                                                          _c("td", [
                                                            _vm._v("Type:")
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                log.data.type
                                                              )
                                                            )
                                                          ])
                                                        ])
                                                      ])
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    : log.type === "discount_updated"
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row align-items-center log-box collapsed",
                                              attrs: {
                                                id: "heading-" + log.id,
                                                "data-toggle": "collapse",
                                                "data-parent": "#accordion",
                                                "data-target":
                                                  "#collapse-" + log.id,
                                                "aria-controls":
                                                  "#collapse-" + log.id
                                              }
                                            },
                                            [
                                              _vm._m(18, true),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-11 d-flex align-items-center justify-content-between flex-row"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "log-description"
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mb-0 log-description"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Discount of " +
                                                              _vm._s(
                                                                log.data.amount
                                                              ) +
                                                              " updated"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "mb-0 log-date"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              log.created_at
                                                            ) +
                                                              " | " +
                                                              _vm._s(
                                                                log.done_by
                                                              )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm._m(19, true)
                                                ]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "collapse",
                                              attrs: {
                                                id: "collapse-" + log.id,
                                                "aria-expanded": "false",
                                                "aria-labelledby":
                                                  "heading-" + log.id,
                                                "data-parent": "#accordion"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c("div", {
                                                    staticClass:
                                                      "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "col-11 pt-3"
                                                    },
                                                    [
                                                      _c(
                                                        "table",
                                                        {
                                                          staticClass:
                                                            "table m-table table-hover log-table"
                                                        },
                                                        [
                                                          _vm._m(20, true),
                                                          _vm._v(" "),
                                                          _c("tbody", [
                                                            log.data.new_name ||
                                                            log.data.old_name
                                                              ? _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Name: "
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.data
                                                                          .old_name
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.data
                                                                          .new_name
                                                                      )
                                                                    )
                                                                  ])
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            log.data
                                                              .old_amount ||
                                                            log.data.new_amount
                                                              ? _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Amount: "
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.data
                                                                          .old_amount
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.data
                                                                          .new_amount
                                                                      )
                                                                    )
                                                                  ])
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" "),
                                                            log.data.new_type ||
                                                            log.data.old_type
                                                              ? _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Type: "
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.data
                                                                          .old_type
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.data
                                                                          .new_type
                                                                      )
                                                                    )
                                                                  ])
                                                                ])
                                                              : _vm._e()
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      : log.type === "discount_deleted"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row align-items-center log-box collapsed",
                                                attrs: {
                                                  id: "heading-" + log.id,
                                                  "data-toggle": "collapse",
                                                  "data-parent": "#accordion",
                                                  "data-target":
                                                    "#collapse-" + log.id,
                                                  "aria-controls":
                                                    "#collapse-" + log.id
                                                }
                                              },
                                              [
                                                _vm._m(21, true),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-11 d-flex align-items-center justify-content-between flex-row"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "log-description"
                                                      },
                                                      [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "mb-0 log-description"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Discount of " +
                                                                _vm._s(
                                                                  log.data
                                                                    .amount
                                                                ) +
                                                                " deleted"
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "mb-0 log-date"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                log.created_at
                                                              ) +
                                                                " | " +
                                                                _vm._s(
                                                                  log.done_by
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._m(22, true)
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "collapse",
                                                attrs: {
                                                  id: "collapse-" + log.id,
                                                  "aria-expanded": "false",
                                                  "aria-labelledby":
                                                    "heading-" + log.id,
                                                  "data-parent": "#accordion"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c("div", {
                                                      staticClass:
                                                        "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-11 pt-3"
                                                      },
                                                      [
                                                        _c(
                                                          "table",
                                                          {
                                                            staticClass:
                                                              "table m-table table-hover log-table"
                                                          },
                                                          [
                                                            _c("tbody", [
                                                              _c("tr", [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "Name:"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      log.data
                                                                        .name
                                                                    )
                                                                  )
                                                                ])
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("tr", [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "Amount:"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      log.data
                                                                        .amount
                                                                    )
                                                                  )
                                                                ])
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("tr", [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    "Type:"
                                                                  )
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      log.data
                                                                        .type
                                                                    )
                                                                  )
                                                                ])
                                                              ])
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        : log.type === "address_created"
                                          ? [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row align-items-center log-box collapsed",
                                                  attrs: {
                                                    id: "heading-" + log.id,
                                                    "data-toggle": "collapse",
                                                    "data-parent": "#accordion",
                                                    "data-target":
                                                      "#collapse-" + log.id,
                                                    "aria-controls":
                                                      "#collapse-" + log.id
                                                  }
                                                },
                                                [
                                                  _vm._m(23, true),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-11 d-flex align-items-center justify-content-between flex-row"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "log-description"
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0 log-description"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Address created"
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0 log-date"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  log.created_at
                                                                ) +
                                                                  " | " +
                                                                  _vm._s(
                                                                    log.done_by
                                                                  )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _vm._m(24, true)
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "collapse",
                                                  attrs: {
                                                    id: "collapse-" + log.id,
                                                    "aria-expanded": "false",
                                                    "aria-labelledby":
                                                      "heading-" + log.id,
                                                    "data-parent": "#accordion"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c("div", {
                                                        staticClass:
                                                          "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-11 pt-3"
                                                        },
                                                        [
                                                          _c(
                                                            "table",
                                                            {
                                                              staticClass:
                                                                "table m-table table-hover log-table"
                                                            },
                                                            [
                                                              _c("tbody", [
                                                                _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Type:"
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.data
                                                                          .type
                                                                      )
                                                                    )
                                                                  ])
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Full address:"
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.data
                                                                          .full_address
                                                                      )
                                                                    )
                                                                  ])
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Floor:"
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.data
                                                                          .floor
                                                                      )
                                                                    )
                                                                  ])
                                                                ]),
                                                                _vm._v(" "),
                                                                _c("tr", [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      "Apartment:"
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.data
                                                                          .apartment
                                                                      )
                                                                    )
                                                                  ])
                                                                ])
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          : log.type === "address_updated"
                                            ? [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row align-items-center log-box collapsed",
                                                    attrs: {
                                                      id: "heading-" + log.id,
                                                      "data-toggle": "collapse",
                                                      "data-parent":
                                                        "#accordion",
                                                      "data-target":
                                                        "#collapse-" + log.id,
                                                      "aria-controls":
                                                        "#collapse-" + log.id
                                                    }
                                                  },
                                                  [
                                                    _vm._m(25, true),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-11 d-flex align-items-center justify-content-between flex-row"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "log-description"
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0 log-description"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Address updated"
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "mb-0 log-date"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    log.created_at
                                                                  ) +
                                                                    " | " +
                                                                    _vm._s(
                                                                      log.done_by
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._m(26, true)
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "collapse",
                                                    attrs: {
                                                      id: "collapse-" + log.id,
                                                      "aria-expanded": "false",
                                                      "aria-labelledby":
                                                        "heading-" + log.id,
                                                      "data-parent":
                                                        "#accordion"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-11 pt-3"
                                                          },
                                                          [
                                                            _c(
                                                              "table",
                                                              {
                                                                staticClass:
                                                                  "table m-table table-hover log-table"
                                                              },
                                                              [
                                                                _vm._m(
                                                                  27,
                                                                  true
                                                                ),
                                                                _vm._v(" "),
                                                                _c("tbody", [
                                                                  log.data
                                                                    .old_type ||
                                                                  log.data
                                                                    .new_type
                                                                    ? _c("tr", [
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              "Type:"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log
                                                                                  .data
                                                                                  .old_type
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log
                                                                                  .data
                                                                                  .new_type
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ])
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  log.data
                                                                    .old_floor ||
                                                                  log.data
                                                                    .new_floor
                                                                    ? _c("tr", [
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              "Floor:"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log
                                                                                  .data
                                                                                  .old_floor
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log
                                                                                  .data
                                                                                  .new_floor
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ])
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  log.data
                                                                    .old_full_address ||
                                                                  log.data
                                                                    .new_full_address
                                                                    ? _c("tr", [
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              "Full address:"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log
                                                                                  .data
                                                                                  .old_full_address
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log
                                                                                  .data
                                                                                  .new_full_address
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ])
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  log.data
                                                                    .old_apartment ||
                                                                  log.data
                                                                    .new_apartment
                                                                    ? _c("tr", [
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              "Apartment:"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log
                                                                                  .data
                                                                                  .old_apartment
                                                                              )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "td",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log
                                                                                  .data
                                                                                  .new_apartment
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ])
                                                                    : _vm._e()
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            : log.type === "address_deleted"
                                              ? [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row align-items-center log-box collapsed",
                                                      attrs: {
                                                        id: "heading-" + log.id,
                                                        "data-toggle":
                                                          "collapse",
                                                        "data-parent":
                                                          "#accordion",
                                                        "data-target":
                                                          "#collapse-" + log.id,
                                                        "aria-controls":
                                                          "#collapse-" + log.id
                                                      }
                                                    },
                                                    [
                                                      _vm._m(28, true),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-11 d-flex align-items-center justify-content-between flex-row"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "log-description"
                                                            },
                                                            [
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "mb-0 log-description"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Address deleted"
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "mb-0 log-date"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      log.created_at
                                                                    ) +
                                                                      " | " +
                                                                      _vm._s(
                                                                        log.done_by
                                                                      )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _vm._m(29, true)
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "collapse",
                                                      attrs: {
                                                        id:
                                                          "collapse-" + log.id,
                                                        "aria-expanded":
                                                          "false",
                                                        "aria-labelledby":
                                                          "heading-" + log.id,
                                                        "data-parent":
                                                          "#accordion"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        { staticClass: "row" },
                                                        [
                                                          _c("div", {
                                                            staticClass:
                                                              "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-11 pt-3"
                                                            },
                                                            [
                                                              _c(
                                                                "table",
                                                                {
                                                                  staticClass:
                                                                    "table m-table table-hover log-table"
                                                                },
                                                                [
                                                                  _c("tbody", [
                                                                    _c("tr", [
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          "Type:"
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            log
                                                                              .data
                                                                              .type
                                                                          )
                                                                        )
                                                                      ])
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("tr", [
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          "Full address:"
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            log
                                                                              .data
                                                                              .full_address
                                                                          )
                                                                        )
                                                                      ])
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("tr", [
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          "Floor:"
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            log
                                                                              .data
                                                                              .floor
                                                                          )
                                                                        )
                                                                      ])
                                                                    ]),
                                                                    _vm._v(" "),
                                                                    _c("tr", [
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          "Apartment:"
                                                                        )
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            log
                                                                              .data
                                                                              .apartment
                                                                          )
                                                                        )
                                                                      ])
                                                                    ])
                                                                  ])
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              : log.type === "time_updated"
                                                ? [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "row align-items-center log-box collapsed",
                                                        attrs: {
                                                          id:
                                                            "heading-" + log.id,
                                                          "data-toggle":
                                                            "collapse",
                                                          "data-parent":
                                                            "#accordion",
                                                          "data-target":
                                                            "#collapse-" +
                                                            log.id,
                                                          "aria-controls":
                                                            "#collapse-" +
                                                            log.id
                                                        }
                                                      },
                                                      [
                                                        _vm._m(30, true),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-11 d-flex align-items-center justify-content-between flex-row"
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "log-description"
                                                              },
                                                              [
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0 log-description"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Move duration changed to " +
                                                                        _vm._s(
                                                                          log
                                                                            .data
                                                                            .new_time
                                                                        )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "p",
                                                                  {
                                                                    staticClass:
                                                                      "mb-0 log-date"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        log.created_at
                                                                      ) +
                                                                        " | " +
                                                                        _vm._s(
                                                                          log.done_by
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _vm._m(31, true)
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "collapse",
                                                        attrs: {
                                                          id:
                                                            "collapse-" +
                                                            log.id,
                                                          "aria-expanded":
                                                            "false",
                                                          "aria-labelledby":
                                                            "heading-" + log.id,
                                                          "data-parent":
                                                            "#accordion"
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "row"
                                                          },
                                                          [
                                                            _c("div", {
                                                              staticClass:
                                                                "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-11 pt-3"
                                                              },
                                                              [
                                                                _c(
                                                                  "table",
                                                                  {
                                                                    staticClass:
                                                                      "table m-table table-hover log-table"
                                                                  },
                                                                  [
                                                                    _vm._m(
                                                                      32,
                                                                      true
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "tbody",
                                                                      [
                                                                        _c(
                                                                          "tr",
                                                                          [
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  "Job time:"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    log
                                                                                      .data
                                                                                      .old_time
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    log
                                                                                      .data
                                                                                      .new_time
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "tr",
                                                                          [
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  "Job total hours overridden:"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    log
                                                                                      .data
                                                                                      .job_total_hours_overridden
                                                                                      ? "Yes"
                                                                                      : "No"
                                                                                  )
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "td"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                : log.type ===
                                                  "double_drive_time_changed"
                                                  ? [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row align-items-center log-box collapsed",
                                                          attrs: {
                                                            id:
                                                              "heading-" +
                                                              log.id,
                                                            "data-toggle":
                                                              "collapse",
                                                            "data-parent":
                                                              "#accordion",
                                                            "data-target":
                                                              "#collapse-" +
                                                              log.id,
                                                            "aria-controls":
                                                              "#collapse-" +
                                                              log.id
                                                          }
                                                        },
                                                        [
                                                          _vm._m(33, true),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-11 d-flex align-items-center justify-content-between flex-row"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "log-description"
                                                                },
                                                                [
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "mb-0 log-description"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Double drive time changed to " +
                                                                          _vm._s(
                                                                            log
                                                                              .data
                                                                              .new_time
                                                                          )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "p",
                                                                    {
                                                                      staticClass:
                                                                        "mb-0 log-date"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          log.created_at
                                                                        ) +
                                                                          " | " +
                                                                          _vm._s(
                                                                            log.done_by
                                                                          )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm._m(34, true)
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "collapse",
                                                          attrs: {
                                                            id:
                                                              "collapse-" +
                                                              log.id,
                                                            "aria-expanded":
                                                              "false",
                                                            "aria-labelledby":
                                                              "heading-" +
                                                              log.id,
                                                            "data-parent":
                                                              "#accordion"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass: "row"
                                                            },
                                                            [
                                                              _c("div", {
                                                                staticClass:
                                                                  "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-11 pt-3"
                                                                },
                                                                [
                                                                  _c(
                                                                    "table",
                                                                    {
                                                                      staticClass:
                                                                        "table m-table table-hover log-table"
                                                                    },
                                                                    [
                                                                      _vm._m(
                                                                        35,
                                                                        true
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "tbody",
                                                                        [
                                                                          log
                                                                            .data
                                                                            .old_time ||
                                                                          log
                                                                            .data
                                                                            .new_time
                                                                            ? _c(
                                                                                "tr",
                                                                                [
                                                                                  _c(
                                                                                    "td",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "DDT:"
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "td",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          log
                                                                                            .data
                                                                                            .old_time
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "td",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          log
                                                                                            .data
                                                                                            .new_time
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            : _vm._e()
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  : log.type ===
                                                    "update_is_small"
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row align-items-center log-box collapsed",
                                                            attrs: {
                                                              id:
                                                                "heading-" +
                                                                log.id,
                                                              "data-toggle":
                                                                "collapse",
                                                              "data-parent":
                                                                "#accordion",
                                                              "data-target":
                                                                "#collapse-" +
                                                                log.id,
                                                              "aria-controls":
                                                                "#collapse-" +
                                                                log.id
                                                            }
                                                          },
                                                          [
                                                            _vm._m(36, true),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "col-11 d-flex align-items-center justify-content-between flex-row"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "log-description"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "mb-0 log-description"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "Job size changed to "
                                                                        ),
                                                                        _c(
                                                                          "b",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log
                                                                                  .data
                                                                                  .new_value
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "p",
                                                                      {
                                                                        staticClass:
                                                                          "mb-0 log-date"
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            log.created_at
                                                                          ) +
                                                                            " | " +
                                                                            _vm._s(
                                                                              log.done_by
                                                                            )
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _vm._m(37, true)
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "collapse",
                                                            attrs: {
                                                              id:
                                                                "collapse-" +
                                                                log.id,
                                                              "aria-expanded":
                                                                "false",
                                                              "aria-labelledby":
                                                                "heading-" +
                                                                log.id,
                                                              "data-parent":
                                                                "#accordion"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "row"
                                                              },
                                                              [
                                                                _c("div", {
                                                                  staticClass:
                                                                    "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-11 pt-3"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "table",
                                                                      {
                                                                        staticClass:
                                                                          "table m-table table-hover log-table"
                                                                      },
                                                                      [
                                                                        _vm._m(
                                                                          38,
                                                                          true
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "tbody",
                                                                          [
                                                                            _c(
                                                                              "tr",
                                                                              [
                                                                                _c(
                                                                                  "td",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Job size:"
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "td",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        log
                                                                                          .data
                                                                                          .old_value
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "td",
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        log
                                                                                          .data
                                                                                          .new_value
                                                                                      )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : log.type ===
                                                      "status_updated"
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "row align-items-center log-box collapsed",
                                                              attrs: {
                                                                id:
                                                                  "heading-" +
                                                                  log.id,
                                                                "data-toggle":
                                                                  "collapse",
                                                                "data-parent":
                                                                  "#accordion",
                                                                "data-target":
                                                                  "#collapse-" +
                                                                  log.id,
                                                                "aria-controls":
                                                                  "#collapse-" +
                                                                  log.id
                                                              }
                                                            },
                                                            [
                                                              _vm._m(39, true),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "log-description"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "mb-0 log-description"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Job status updated to " +
                                                                              _vm._s(
                                                                                log
                                                                                  .data
                                                                                  .new_status
                                                                              )
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "p",
                                                                        {
                                                                          staticClass:
                                                                            "mb-0 log-date"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              log.created_at
                                                                            ) +
                                                                              " | " +
                                                                              _vm._s(
                                                                                log.done_by
                                                                              )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm._m(
                                                                    40,
                                                                    true
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "collapse",
                                                              attrs: {
                                                                id:
                                                                  "collapse-" +
                                                                  log.id,
                                                                "aria-expanded":
                                                                  "false",
                                                                "aria-labelledby":
                                                                  "heading-" +
                                                                  log.id,
                                                                "data-parent":
                                                                  "#accordion"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "row"
                                                                },
                                                                [
                                                                  _c("div", {
                                                                    staticClass:
                                                                      "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col-11 pt-3"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "table",
                                                                        {
                                                                          staticClass:
                                                                            "table m-table table-hover log-table"
                                                                        },
                                                                        [
                                                                          _vm._m(
                                                                            41,
                                                                            true
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "tbody",
                                                                            [
                                                                              _c(
                                                                                "tr",
                                                                                [
                                                                                  _c(
                                                                                    "td",
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Status:"
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "td",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          log
                                                                                            .data
                                                                                            .old_status
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "td",
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          log
                                                                                            .data
                                                                                            .new_status
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      : log.type ===
                                                        "assign_carriers"
                                                        ? [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "row align-items-center log-box collapsed",
                                                                attrs: {
                                                                  id:
                                                                    "heading-" +
                                                                    log.id,
                                                                  "data-toggle":
                                                                    "collapse",
                                                                  "data-parent":
                                                                    "#accordion",
                                                                  "data-target":
                                                                    "#collapse-" +
                                                                    log.id,
                                                                  "aria-controls":
                                                                    "#collapse-" +
                                                                    log.id
                                                                }
                                                              },
                                                              [
                                                                _vm._m(
                                                                  42,
                                                                  true
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "log-description"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "mb-0 log-description"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "Job assigned to carrier: " +
                                                                                _vm._s(
                                                                                  log
                                                                                    .data
                                                                                    .new_carrier
                                                                                )
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "p",
                                                                          {
                                                                            staticClass:
                                                                              "mb-0 log-date"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                log.created_at
                                                                              ) +
                                                                                " | " +
                                                                                _vm._s(
                                                                                  log.done_by
                                                                                )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _vm._m(
                                                                      43,
                                                                      true
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "collapse",
                                                                attrs: {
                                                                  id:
                                                                    "collapse-" +
                                                                    log.id,
                                                                  "aria-expanded":
                                                                    "false",
                                                                  "aria-labelledby":
                                                                    "heading-" +
                                                                    log.id,
                                                                  "data-parent":
                                                                    "#accordion"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row"
                                                                  },
                                                                  [
                                                                    _c("div", {
                                                                      staticClass:
                                                                        "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                    }),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col-11 pt-3"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "table",
                                                                          {
                                                                            staticClass:
                                                                              "table m-table table-hover log-table"
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              44,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "tbody",
                                                                              [
                                                                                _c(
                                                                                  "tr",
                                                                                  [
                                                                                    _c(
                                                                                      "td",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "Carrier:"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "td",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            log
                                                                                              .data
                                                                                              .old_carrier
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "td",
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            log
                                                                                              .data
                                                                                              .new_carrier
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        : log.type ===
                                                          "assign_movers"
                                                          ? [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "row align-items-center log-box collapsed",
                                                                  attrs: {
                                                                    id:
                                                                      "heading-" +
                                                                      log.id,
                                                                    "data-toggle":
                                                                      "collapse",
                                                                    "data-parent":
                                                                      "#accordion",
                                                                    "data-target":
                                                                      "#collapse-" +
                                                                      log.id,
                                                                    "aria-controls":
                                                                      "#collapse-" +
                                                                      log.id
                                                                  }
                                                                },
                                                                [
                                                                  _vm._m(
                                                                    45,
                                                                    true
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "log-description"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "mb-0 log-description"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "\n                    Mover(s) assignment changed\n                  "
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "p",
                                                                            {
                                                                              staticClass:
                                                                                "mb-0 log-date"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  log.created_at
                                                                                ) +
                                                                                  " | " +
                                                                                  _vm._s(
                                                                                    log.done_by
                                                                                  )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _vm._m(
                                                                        46,
                                                                        true
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "collapse",
                                                                  attrs: {
                                                                    id:
                                                                      "collapse-" +
                                                                      log.id,
                                                                    "aria-expanded":
                                                                      "false",
                                                                    "aria-labelledby":
                                                                      "heading-" +
                                                                      log.id,
                                                                    "data-parent":
                                                                      "#accordion"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "row"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "col-11 pt-3"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "table",
                                                                            {
                                                                              staticClass:
                                                                                "table m-table table-hover log-table"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "tbody",
                                                                                [
                                                                                  log
                                                                                    .data
                                                                                    .assigned_foreman
                                                                                    ? _c(
                                                                                        "tr",
                                                                                        [
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Assigned foreman:"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  log
                                                                                                    .data
                                                                                                    .assigned_foreman
                                                                                                )
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "tr",
                                                                                    [
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Assigned movers:"
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              log
                                                                                                .data
                                                                                                .assigned_movers
                                                                                            )
                                                                                          ),
                                                                                          log
                                                                                            .data
                                                                                            .removed_movers
                                                                                            ? [
                                                                                                log
                                                                                                  .data
                                                                                                  .assigned_movers
                                                                                                  ? [
                                                                                                      _vm._v(
                                                                                                        ", "
                                                                                                      )
                                                                                                    ]
                                                                                                  : _vm._e(),
                                                                                                _c(
                                                                                                  "span",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "removed-movers-trucks"
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        log
                                                                                                          .data
                                                                                                          .removed_movers
                                                                                                      )
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            : _vm._e()
                                                                                        ],
                                                                                        2
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          : log.type ===
                                                            "assign_trucks"
                                                            ? [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "row align-items-center log-box collapsed",
                                                                    attrs: {
                                                                      id:
                                                                        "heading-" +
                                                                        log.id,
                                                                      "data-toggle":
                                                                        "collapse",
                                                                      "data-parent":
                                                                        "#accordion",
                                                                      "data-target":
                                                                        "#collapse-" +
                                                                        log.id,
                                                                      "aria-controls":
                                                                        "#collapse-" +
                                                                        log.id
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._m(
                                                                      47,
                                                                      true
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "log-description"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-0 log-description"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "Truck(s) assignment changed"
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "p",
                                                                              {
                                                                                staticClass:
                                                                                  "mb-0 log-date"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    log.created_at
                                                                                  ) +
                                                                                    " | " +
                                                                                    _vm._s(
                                                                                      log.done_by
                                                                                    )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm._m(
                                                                          48,
                                                                          true
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "collapse",
                                                                    attrs: {
                                                                      id:
                                                                        "collapse-" +
                                                                        log.id,
                                                                      "aria-expanded":
                                                                        "false",
                                                                      "aria-labelledby":
                                                                        "heading-" +
                                                                        log.id,
                                                                      "data-parent":
                                                                        "#accordion"
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "row"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "col-11 pt-3"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "table",
                                                                              {
                                                                                staticClass:
                                                                                  "table m-table table-hover log-table"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "tbody",
                                                                                  [
                                                                                    _c(
                                                                                      "tr",
                                                                                      [
                                                                                        _c(
                                                                                          "td",
                                                                                          [
                                                                                            _vm._v(
                                                                                              "Assigned trucks:"
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "td",
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                log
                                                                                                  .data
                                                                                                  .assigned_trucks
                                                                                              )
                                                                                            ),
                                                                                            log
                                                                                              .data
                                                                                              .removed_trucks
                                                                                              ? [
                                                                                                  log
                                                                                                    .data
                                                                                                    .assigned_trucks
                                                                                                    ? [
                                                                                                        _vm._v(
                                                                                                          ", "
                                                                                                        )
                                                                                                      ]
                                                                                                    : _vm._e(),
                                                                                                  _c(
                                                                                                    "span",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "removed-movers-trucks"
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .removed_trucks
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              : _vm._e()
                                                                                          ],
                                                                                          2
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            : log.type ===
                                                              "charge_created"
                                                              ? [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "row align-items-center log-box collapsed d-flex",
                                                                      attrs: {
                                                                        id:
                                                                          "heading-" +
                                                                          log.id,
                                                                        "data-toggle":
                                                                          "collapse",
                                                                        "data-parent":
                                                                          "#accordion",
                                                                        "data-target":
                                                                          "#collapse-" +
                                                                          log.id,
                                                                        "aria-controls":
                                                                          "#collapse-" +
                                                                          log.id
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._m(
                                                                        49,
                                                                        true
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "log-description"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mb-0 log-description"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      log
                                                                                        .data
                                                                                        .payment_type
                                                                                    ) +
                                                                                      " of $" +
                                                                                      _vm._s(
                                                                                        log
                                                                                          .data
                                                                                          .amount
                                                                                      ) +
                                                                                      " created"
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "p",
                                                                                {
                                                                                  staticClass:
                                                                                    "mb-0 log-date"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      log.created_at
                                                                                    ) +
                                                                                      " | " +
                                                                                      _vm._s(
                                                                                        log.done_by
                                                                                      )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _vm._m(
                                                                            50,
                                                                            true
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "collapse",
                                                                      attrs: {
                                                                        id:
                                                                          "collapse-" +
                                                                          log.id,
                                                                        "aria-expanded":
                                                                          "false",
                                                                        "aria-labelledby":
                                                                          "heading-" +
                                                                          log.id,
                                                                        "data-parent":
                                                                          "#accordion"
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "row"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                            }
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-11 pt-3"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "table",
                                                                                {
                                                                                  staticClass:
                                                                                    "table m-table table-hover log-table"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "tbody",
                                                                                    [
                                                                                      _c(
                                                                                        "tr",
                                                                                        [
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Amount:"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "$ " +
                                                                                                  _vm._s(
                                                                                                    log
                                                                                                      .data
                                                                                                      .amount
                                                                                                  )
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "tr",
                                                                                        [
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Note:"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  log
                                                                                                    .data
                                                                                                    .note
                                                                                                )
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      log
                                                                                        .data
                                                                                        .charge_fee
                                                                                        ? _c(
                                                                                            "tr",
                                                                                            [
                                                                                              _c(
                                                                                                "td",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "Charge fee:"
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "td",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      log
                                                                                                        .data
                                                                                                        .charge_fee
                                                                                                    )
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        : _vm._e(),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "tr",
                                                                                        [
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Payment method:"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "td",
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  log
                                                                                                    .data
                                                                                                    .payment_method
                                                                                                )
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              : log.type ===
                                                                "charge_deleted"
                                                                ? [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "row align-items-center log-box collapsed",
                                                                        attrs: {
                                                                          id:
                                                                            "heading-" +
                                                                            log.id,
                                                                          "data-toggle":
                                                                            "collapse",
                                                                          "data-parent":
                                                                            "#accordion",
                                                                          "data-target":
                                                                            "#collapse-" +
                                                                            log.id,
                                                                          "aria-controls":
                                                                            "#collapse-" +
                                                                            log.id
                                                                        }
                                                                      },
                                                                      [
                                                                        _vm._m(
                                                                          51,
                                                                          true
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "log-description"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "mb-0 log-description"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        log
                                                                                          .data
                                                                                          .payment_type
                                                                                      ) +
                                                                                        " of $" +
                                                                                        _vm._s(
                                                                                          log
                                                                                            .data
                                                                                            .amount
                                                                                        ) +
                                                                                        " deleted"
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "p",
                                                                                  {
                                                                                    staticClass:
                                                                                      "mb-0 log-date"
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        log.created_at
                                                                                      ) +
                                                                                        " | " +
                                                                                        _vm._s(
                                                                                          log.done_by
                                                                                        )
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _vm._m(
                                                                              52,
                                                                              true
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "collapse",
                                                                        attrs: {
                                                                          id:
                                                                            "collapse-" +
                                                                            log.id,
                                                                          "aria-expanded":
                                                                            "false",
                                                                          "aria-labelledby":
                                                                            "heading-" +
                                                                            log.id,
                                                                          "data-parent":
                                                                            "#accordion"
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "row"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "col-11 pt-3"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "table",
                                                                                  {
                                                                                    staticClass:
                                                                                      "table m-table table-hover log-table"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "tbody",
                                                                                      [
                                                                                        _c(
                                                                                          "tr",
                                                                                          [
                                                                                            _c(
                                                                                              "td",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Amount:"
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "td",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "$" +
                                                                                                    _vm._s(
                                                                                                      log
                                                                                                        .data
                                                                                                        .amount
                                                                                                    )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "tr",
                                                                                          [
                                                                                            _c(
                                                                                              "td",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Note:"
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "td",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    log
                                                                                                      .data
                                                                                                      .note
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        log
                                                                                          .data
                                                                                          .charge_fee
                                                                                          ? _c(
                                                                                              "tr",
                                                                                              [
                                                                                                _c(
                                                                                                  "td",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "Charge fee:"
                                                                                                    )
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "td",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        log
                                                                                                          .data
                                                                                                          .charge_fee
                                                                                                      )
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          : _vm._e(),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "tr",
                                                                                          [
                                                                                            _c(
                                                                                              "td",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Payment method:"
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "td",
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    log
                                                                                                      .data
                                                                                                      .payment_method
                                                                                                  )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                : log.type ===
                                                                  "charge_updated"
                                                                  ? [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "row align-items-center log-box collapsed",
                                                                          attrs: {
                                                                            id:
                                                                              "heading-" +
                                                                              log.id,
                                                                            "data-toggle":
                                                                              "collapse",
                                                                            "data-parent":
                                                                              "#accordion",
                                                                            "data-target":
                                                                              "#collapse-" +
                                                                              log.id,
                                                                            "aria-controls":
                                                                              "#collapse-" +
                                                                              log.id
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._m(
                                                                            53,
                                                                            true
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "log-description"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-0 log-description"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          log
                                                                                            .data
                                                                                            .payment_type
                                                                                        ) +
                                                                                          " of $" +
                                                                                          _vm._s(
                                                                                            log
                                                                                              .data
                                                                                              .new_amount
                                                                                          ) +
                                                                                          " updated"
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "p",
                                                                                    {
                                                                                      staticClass:
                                                                                        "mb-0 log-date"
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          log.created_at
                                                                                        ) +
                                                                                          " | " +
                                                                                          _vm._s(
                                                                                            log.done_by
                                                                                          )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _vm._m(
                                                                                54,
                                                                                true
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "collapse",
                                                                          attrs: {
                                                                            id:
                                                                              "collapse-" +
                                                                              log.id,
                                                                            "aria-expanded":
                                                                              "false",
                                                                            "aria-labelledby":
                                                                              "heading-" +
                                                                              log.id,
                                                                            "data-parent":
                                                                              "#accordion"
                                                                          }
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-11 pt-3"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "table",
                                                                                    {
                                                                                      staticClass:
                                                                                        "table m-table table-hover log-table"
                                                                                    },
                                                                                    [
                                                                                      _vm._m(
                                                                                        55,
                                                                                        true
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "tbody",
                                                                                        [
                                                                                          log
                                                                                            .data
                                                                                            .old_amount ||
                                                                                          log
                                                                                            .data
                                                                                            .new_amount
                                                                                            ? _c(
                                                                                                "tr",
                                                                                                [
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "Amount:"
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .old_amount
                                                                                                            ? "$ " +
                                                                                                              log
                                                                                                                .data
                                                                                                                .old_amount
                                                                                                            : ""
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .new_amount
                                                                                                            ? "$ " +
                                                                                                              log
                                                                                                                .data
                                                                                                                .new_amount
                                                                                                            : ""
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          log
                                                                                            .data
                                                                                            .old_charge_fee ||
                                                                                          log
                                                                                            .data
                                                                                            .new_charge_fee
                                                                                            ? _c(
                                                                                                "tr",
                                                                                                [
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "Charge fee:"
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .old_charge_fee
                                                                                                            ? "$ " +
                                                                                                              log
                                                                                                                .data
                                                                                                                .old_charge_fee
                                                                                                            : ""
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .new_charge_fee
                                                                                                            ? "$ " +
                                                                                                              log
                                                                                                                .data
                                                                                                                .new_charge_fee
                                                                                                            : ""
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          log
                                                                                            .data
                                                                                            .old_note ||
                                                                                          log
                                                                                            .data
                                                                                            .new_note
                                                                                            ? _c(
                                                                                                "tr",
                                                                                                [
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "Note:"
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .old_note
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .new_note
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          log
                                                                                            .data
                                                                                            .old_payment_method ||
                                                                                          log
                                                                                            .data
                                                                                            .new_payment_method
                                                                                            ? _c(
                                                                                                "tr",
                                                                                                [
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "Payment method:"
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .old_payment_method
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .new_payment_method
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e(),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          log
                                                                                            .data
                                                                                            .old_payment_type ||
                                                                                          log
                                                                                            .data
                                                                                            .new_payment_type
                                                                                            ? _c(
                                                                                                "tr",
                                                                                                [
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "Payment type:"
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .old_payment_type
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "td",
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log
                                                                                                            .data
                                                                                                            .new_payment_type
                                                                                                        )
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            : _vm._e()
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  : log.type ===
                                                                    "assign_user"
                                                                    ? [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "row align-items-center log-box collapsed",
                                                                            attrs: {
                                                                              id:
                                                                                "heading-" +
                                                                                log.id,
                                                                              "data-toggle":
                                                                                "collapse",
                                                                              "data-parent":
                                                                                "#accordion",
                                                                              "data-target":
                                                                                "#collapse-" +
                                                                                log.id,
                                                                              "aria-controls":
                                                                                "#collapse-" +
                                                                                log.id
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._m(
                                                                              56,
                                                                              true
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "log-description"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "p",
                                                                                      {
                                                                                        staticClass:
                                                                                          "mb-0 log-description"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "User " +
                                                                                            _vm._s(
                                                                                              log
                                                                                                .data
                                                                                                .new_user
                                                                                            ) +
                                                                                            " assigned to the job"
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "p",
                                                                                      {
                                                                                        staticClass:
                                                                                          "mb-0 log-date"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            log.created_at
                                                                                          ) +
                                                                                            " | " +
                                                                                            _vm._s(
                                                                                              log.done_by
                                                                                            )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _vm._m(
                                                                                  57,
                                                                                  true
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "collapse",
                                                                            attrs: {
                                                                              id:
                                                                                "collapse-" +
                                                                                log.id,
                                                                              "aria-expanded":
                                                                                "false",
                                                                              "aria-labelledby":
                                                                                "heading-" +
                                                                                log.id,
                                                                              "data-parent":
                                                                                "#accordion"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "row"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col-11 pt-3"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "table",
                                                                                      {
                                                                                        staticClass:
                                                                                          "table m-table table-hover log-table"
                                                                                      },
                                                                                      [
                                                                                        _vm._m(
                                                                                          58,
                                                                                          true
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "tbody",
                                                                                          [
                                                                                            _c(
                                                                                              "tr",
                                                                                              [
                                                                                                _c(
                                                                                                  "td",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "Assigned user:"
                                                                                                    )
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "td",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        log
                                                                                                          .data
                                                                                                          .old_user
                                                                                                      )
                                                                                                    )
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "td",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        log
                                                                                                          .data
                                                                                                          .new_user
                                                                                                      )
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    : log.type ===
                                                                      "send_pre_agreement"
                                                                      ? [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row align-items-center log-box collapsed",
                                                                              attrs: {
                                                                                id:
                                                                                  "heading-" +
                                                                                  log.id,
                                                                                "data-toggle":
                                                                                  "collapse",
                                                                                "data-parent":
                                                                                  "#accordion",
                                                                                "data-target":
                                                                                  "#collapse-" +
                                                                                  log.id,
                                                                                "aria-controls":
                                                                                  "#collapse-" +
                                                                                  log.id
                                                                              }
                                                                            },
                                                                            [
                                                                              _vm._m(
                                                                                59,
                                                                                true
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "log-description"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-0 log-description"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "Pre agreement contract sent to the customer"
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "p",
                                                                                        {
                                                                                          staticClass:
                                                                                            "mb-0 log-date"
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              log.created_at
                                                                                            ) +
                                                                                              " | " +
                                                                                              _vm._s(
                                                                                                log.done_by
                                                                                              )
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _vm._m(
                                                                                    60,
                                                                                    true
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "collapse",
                                                                              attrs: {
                                                                                id:
                                                                                  "collapse-" +
                                                                                  log.id,
                                                                                "aria-expanded":
                                                                                  "false",
                                                                                "aria-labelledby":
                                                                                  "heading-" +
                                                                                  log.id,
                                                                                "data-parent":
                                                                                  "#accordion"
                                                                              }
                                                                            }
                                                                          )
                                                                        ]
                                                                      : log.type ===
                                                                        "job_updates_email_sent"
                                                                        ? [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "row align-items-center log-box collapsed",
                                                                                attrs: {
                                                                                  id:
                                                                                    "heading-" +
                                                                                    log.id,
                                                                                  "data-toggle":
                                                                                    "collapse",
                                                                                  "data-parent":
                                                                                    "#accordion",
                                                                                  "data-target":
                                                                                    "#collapse-" +
                                                                                    log.id,
                                                                                  "aria-controls":
                                                                                    "#collapse-" +
                                                                                    log.id
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._m(
                                                                                  61,
                                                                                  true
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "log-description"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "p",
                                                                                          {
                                                                                            staticClass:
                                                                                              "mb-0 log-description"
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              "Email with updates sent to customer"
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "p",
                                                                                          {
                                                                                            staticClass:
                                                                                              "mb-0 log-date"
                                                                                          },
                                                                                          [
                                                                                            _vm._v(
                                                                                              _vm._s(
                                                                                                log.created_at
                                                                                              ) +
                                                                                                " | " +
                                                                                                _vm._s(
                                                                                                  log.done_by
                                                                                                )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _vm._m(
                                                                                      62,
                                                                                      true
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "collapse",
                                                                                attrs: {
                                                                                  id:
                                                                                    "collapse-" +
                                                                                    log.id,
                                                                                  "aria-expanded":
                                                                                    "false",
                                                                                  "aria-labelledby":
                                                                                    "heading-" +
                                                                                    log.id,
                                                                                  "data-parent":
                                                                                    "#accordion"
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "row"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "col-11 pt-3"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "table",
                                                                                          {
                                                                                            staticClass:
                                                                                              "table m-table table-hover log-table"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "tbody",
                                                                                              _vm._l(
                                                                                                log.data,
                                                                                                function(
                                                                                                  change,
                                                                                                  index
                                                                                                ) {
                                                                                                  return _c(
                                                                                                    "tr",
                                                                                                    {
                                                                                                      key: index
                                                                                                    },
                                                                                                    [
                                                                                                      _c(
                                                                                                        "td",
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              change
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "td"
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                }
                                                                                              )
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        : log.type ===
                                                                          "customer_note_created"
                                                                          ? [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "row align-items-center log-box collapsed",
                                                                                  attrs: {
                                                                                    id:
                                                                                      "heading-" +
                                                                                      log.id,
                                                                                    "data-toggle":
                                                                                      "collapse",
                                                                                    "data-parent":
                                                                                      "#accordion",
                                                                                    "data-target":
                                                                                      "#collapse-" +
                                                                                      log.id,
                                                                                    "aria-controls":
                                                                                      "#collapse-" +
                                                                                      log.id
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _vm._m(
                                                                                    63,
                                                                                    true
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "log-description"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "p",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mb-0 log-description"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                "Customer note created"
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "p",
                                                                                            {
                                                                                              staticClass:
                                                                                                "mb-0 log-date"
                                                                                            },
                                                                                            [
                                                                                              _vm._v(
                                                                                                _vm._s(
                                                                                                  log.created_at
                                                                                                ) +
                                                                                                  " | " +
                                                                                                  _vm._s(
                                                                                                    log.done_by
                                                                                                  )
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _vm._m(
                                                                                        64,
                                                                                        true
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "collapse",
                                                                                  attrs: {
                                                                                    id:
                                                                                      "collapse-" +
                                                                                      log.id,
                                                                                    "aria-expanded":
                                                                                      "false",
                                                                                    "aria-labelledby":
                                                                                      "heading-" +
                                                                                      log.id,
                                                                                    "data-parent":
                                                                                      "#accordion"
                                                                                  }
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row"
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                                        }
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-11 pt-3"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "table",
                                                                                            {
                                                                                              staticClass:
                                                                                                "table m-table table-hover log-table"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "tbody",
                                                                                                [
                                                                                                  _c(
                                                                                                    "tr",
                                                                                                    [
                                                                                                      _c(
                                                                                                        "td",
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            "Note:"
                                                                                                          )
                                                                                                        ]
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "td",
                                                                                                        [
                                                                                                          _vm._v(
                                                                                                            _vm._s(
                                                                                                              log
                                                                                                                .data
                                                                                                                .value
                                                                                                            )
                                                                                                          )
                                                                                                        ]
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          : log.type ===
                                                                            "customer_note_updated"
                                                                            ? [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "row align-items-center log-box collapsed",
                                                                                    attrs: {
                                                                                      id:
                                                                                        "heading-" +
                                                                                        log.id,
                                                                                      "data-toggle":
                                                                                        "collapse",
                                                                                      "data-parent":
                                                                                        "#accordion",
                                                                                      "data-target":
                                                                                        "#collapse-" +
                                                                                        log.id,
                                                                                      "aria-controls":
                                                                                        "#collapse-" +
                                                                                        log.id
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._m(
                                                                                      65,
                                                                                      true
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "log-description"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "p",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "mb-0 log-description"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  "Customer note updated"
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "p",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "mb-0 log-date"
                                                                                              },
                                                                                              [
                                                                                                _vm._v(
                                                                                                  _vm._s(
                                                                                                    log.created_at
                                                                                                  ) +
                                                                                                    " | " +
                                                                                                    _vm._s(
                                                                                                      log.done_by
                                                                                                    )
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _vm._m(
                                                                                          66,
                                                                                          true
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "collapse",
                                                                                    attrs: {
                                                                                      id:
                                                                                        "collapse-" +
                                                                                        log.id,
                                                                                      "aria-expanded":
                                                                                        "false",
                                                                                      "aria-labelledby":
                                                                                        "heading-" +
                                                                                        log.id,
                                                                                      "data-parent":
                                                                                        "#accordion"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "row"
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                                          }
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "col-11 pt-3"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "table",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "table m-table table-hover log-table"
                                                                                              },
                                                                                              [
                                                                                                _vm._m(
                                                                                                  67,
                                                                                                  true
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "tbody",
                                                                                                  [
                                                                                                    _c(
                                                                                                      "tr",
                                                                                                      [
                                                                                                        _c(
                                                                                                          "td",
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              "Note:"
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " "
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "td",
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              _vm._s(
                                                                                                                log
                                                                                                                  .data
                                                                                                                  .old_value
                                                                                                              )
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " "
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "td",
                                                                                                          [
                                                                                                            _vm._v(
                                                                                                              _vm._s(
                                                                                                                log
                                                                                                                  .data
                                                                                                                  .new_value
                                                                                                              )
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            : log.type ===
                                                                              "customer_updated"
                                                                              ? [
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "row align-items-center log-box collapsed",
                                                                                      attrs: {
                                                                                        id:
                                                                                          "heading-" +
                                                                                          log.id,
                                                                                        "data-toggle":
                                                                                          "collapse",
                                                                                        "data-parent":
                                                                                          "#accordion",
                                                                                        "data-target":
                                                                                          "#collapse-" +
                                                                                          log.id,
                                                                                        "aria-controls":
                                                                                          "#collapse-" +
                                                                                          log.id
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._m(
                                                                                        68,
                                                                                        true
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "log-description"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "p",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "mb-0 log-description"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    "Customer updated"
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "p",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "mb-0 log-date"
                                                                                                },
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      log.created_at
                                                                                                    ) +
                                                                                                      " | " +
                                                                                                      _vm._s(
                                                                                                        log.done_by
                                                                                                      )
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _vm._m(
                                                                                            69,
                                                                                            true
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "collapse",
                                                                                      attrs: {
                                                                                        id:
                                                                                          "collapse-" +
                                                                                          log.id,
                                                                                        "aria-expanded":
                                                                                          "false",
                                                                                        "aria-labelledby":
                                                                                          "heading-" +
                                                                                          log.id,
                                                                                        "data-parent":
                                                                                          "#accordion"
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "row"
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                                            }
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "col-11 pt-3"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "table",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "table m-table table-hover log-table"
                                                                                                },
                                                                                                [
                                                                                                  _vm._m(
                                                                                                    70,
                                                                                                    true
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "tbody",
                                                                                                    [
                                                                                                      log
                                                                                                        .data
                                                                                                        .old_email ||
                                                                                                      log
                                                                                                        .data
                                                                                                        .new_email
                                                                                                        ? _c(
                                                                                                            "tr",
                                                                                                            [
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    "Email:"
                                                                                                                  )
                                                                                                                ]
                                                                                                              ),
                                                                                                              _vm._v(
                                                                                                                " "
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    _vm._s(
                                                                                                                      log
                                                                                                                        .data
                                                                                                                        .old_email
                                                                                                                    )
                                                                                                                  )
                                                                                                                ]
                                                                                                              ),
                                                                                                              _vm._v(
                                                                                                                " "
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    _vm._s(
                                                                                                                      log
                                                                                                                        .data
                                                                                                                        .new_email
                                                                                                                    )
                                                                                                                  )
                                                                                                                ]
                                                                                                              )
                                                                                                            ]
                                                                                                          )
                                                                                                        : _vm._e(),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      log
                                                                                                        .data
                                                                                                        .old_first_name ||
                                                                                                      log
                                                                                                        .data
                                                                                                        .new_first_name
                                                                                                        ? _c(
                                                                                                            "tr",
                                                                                                            [
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    "First name:"
                                                                                                                  )
                                                                                                                ]
                                                                                                              ),
                                                                                                              _vm._v(
                                                                                                                " "
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    _vm._s(
                                                                                                                      log
                                                                                                                        .data
                                                                                                                        .old_first_name
                                                                                                                    )
                                                                                                                  )
                                                                                                                ]
                                                                                                              ),
                                                                                                              _vm._v(
                                                                                                                " "
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    _vm._s(
                                                                                                                      log
                                                                                                                        .data
                                                                                                                        .new_first_name
                                                                                                                    )
                                                                                                                  )
                                                                                                                ]
                                                                                                              )
                                                                                                            ]
                                                                                                          )
                                                                                                        : _vm._e(),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      log
                                                                                                        .data
                                                                                                        .old_last_name ||
                                                                                                      log
                                                                                                        .data
                                                                                                        .new_last_name
                                                                                                        ? _c(
                                                                                                            "tr",
                                                                                                            [
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    "Last name:"
                                                                                                                  )
                                                                                                                ]
                                                                                                              ),
                                                                                                              _vm._v(
                                                                                                                " "
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    _vm._s(
                                                                                                                      log
                                                                                                                        .data
                                                                                                                        .old_last_name
                                                                                                                    )
                                                                                                                  )
                                                                                                                ]
                                                                                                              ),
                                                                                                              _vm._v(
                                                                                                                " "
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    _vm._s(
                                                                                                                      log
                                                                                                                        .data
                                                                                                                        .new_last_name
                                                                                                                    )
                                                                                                                  )
                                                                                                                ]
                                                                                                              )
                                                                                                            ]
                                                                                                          )
                                                                                                        : _vm._e(),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      log
                                                                                                        .data
                                                                                                        .old_phone ||
                                                                                                      log
                                                                                                        .data
                                                                                                        .new_phone
                                                                                                        ? _c(
                                                                                                            "tr",
                                                                                                            [
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    "Phone:"
                                                                                                                  )
                                                                                                                ]
                                                                                                              ),
                                                                                                              _vm._v(
                                                                                                                " "
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    _vm._s(
                                                                                                                      log
                                                                                                                        .data
                                                                                                                        .old_phone
                                                                                                                    )
                                                                                                                  )
                                                                                                                ]
                                                                                                              ),
                                                                                                              _vm._v(
                                                                                                                " "
                                                                                                              ),
                                                                                                              _c(
                                                                                                                "td",
                                                                                                                [
                                                                                                                  _vm._v(
                                                                                                                    _vm._s(
                                                                                                                      log
                                                                                                                        .data
                                                                                                                        .new_phone
                                                                                                                    )
                                                                                                                  )
                                                                                                                ]
                                                                                                              )
                                                                                                            ]
                                                                                                          )
                                                                                                        : _vm._e()
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              : log.type ===
                                                                                "claim_created"
                                                                                ? [
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "row align-items-center log-box collapsed",
                                                                                        attrs: {
                                                                                          id:
                                                                                            "heading-" +
                                                                                            log.id,
                                                                                          "data-toggle":
                                                                                            "collapse",
                                                                                          "data-parent":
                                                                                            "#accordion",
                                                                                          "data-target":
                                                                                            "#collapse-" +
                                                                                            log.id,
                                                                                          "aria-controls":
                                                                                            "#collapse-" +
                                                                                            log.id
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._m(
                                                                                          71,
                                                                                          true
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "log-description"
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "p",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "mb-0 log-description"
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      "Claim created"
                                                                                                    )
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "p",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "mb-0 log-date"
                                                                                                  },
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        log.created_at
                                                                                                      ) +
                                                                                                        " | " +
                                                                                                        _vm._s(
                                                                                                          log.done_by
                                                                                                        )
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _vm._m(
                                                                                              72,
                                                                                              true
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "div",
                                                                                      {
                                                                                        staticClass:
                                                                                          "collapse",
                                                                                        attrs: {
                                                                                          id:
                                                                                            "collapse-" +
                                                                                            log.id,
                                                                                          "aria-expanded":
                                                                                            "false",
                                                                                          "aria-labelledby":
                                                                                            "heading-" +
                                                                                            log.id,
                                                                                          "data-parent":
                                                                                            "#accordion"
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "row"
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                                              }
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "col-11 pt-3"
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "table",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "table m-table table-hover log-table"
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "tbody",
                                                                                                      [
                                                                                                        _c(
                                                                                                          "tr",
                                                                                                          [
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "Ref:"
                                                                                                                )
                                                                                                              ]
                                                                                                            ),
                                                                                                            _vm._v(
                                                                                                              " "
                                                                                                            ),
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  _vm._s(
                                                                                                                    log
                                                                                                                      .data
                                                                                                                      .ref_id
                                                                                                                  )
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " "
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "tr",
                                                                                                          [
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "Claim type:"
                                                                                                                )
                                                                                                              ]
                                                                                                            ),
                                                                                                            _vm._v(
                                                                                                              " "
                                                                                                            ),
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  _vm._s(
                                                                                                                    log
                                                                                                                      .data
                                                                                                                      .claim_type
                                                                                                                  )
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " "
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "tr",
                                                                                                          [
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "Claim priority:"
                                                                                                                )
                                                                                                              ]
                                                                                                            ),
                                                                                                            _vm._v(
                                                                                                              " "
                                                                                                            ),
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  _vm._s(
                                                                                                                    log
                                                                                                                      .data
                                                                                                                      .claim_priority
                                                                                                                  )
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " "
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "tr",
                                                                                                          [
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "Title:"
                                                                                                                )
                                                                                                              ]
                                                                                                            ),
                                                                                                            _vm._v(
                                                                                                              " "
                                                                                                            ),
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  _vm._s(
                                                                                                                    log
                                                                                                                      .data
                                                                                                                      .title
                                                                                                                  )
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " "
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "tr",
                                                                                                          [
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "Description:"
                                                                                                                )
                                                                                                              ]
                                                                                                            ),
                                                                                                            _vm._v(
                                                                                                              " "
                                                                                                            ),
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  _vm._s(
                                                                                                                    log
                                                                                                                      .data
                                                                                                                      .description
                                                                                                                  )
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ]
                                                                                                        ),
                                                                                                        _vm._v(
                                                                                                          " "
                                                                                                        ),
                                                                                                        _c(
                                                                                                          "tr",
                                                                                                          [
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  "Assigned to:"
                                                                                                                )
                                                                                                              ]
                                                                                                            ),
                                                                                                            _vm._v(
                                                                                                              " "
                                                                                                            ),
                                                                                                            _c(
                                                                                                              "td",
                                                                                                              [
                                                                                                                _vm._v(
                                                                                                                  _vm._s(
                                                                                                                    log
                                                                                                                      .data
                                                                                                                      .assigned_to
                                                                                                                  )
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                : log.type ===
                                                                                  "address_note_updated"
                                                                                  ? [
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "row align-items-center log-box collapsed",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "heading-" +
                                                                                              log.id,
                                                                                            "data-toggle":
                                                                                              "collapse",
                                                                                            "data-parent":
                                                                                              "#accordion",
                                                                                            "data-target":
                                                                                              "#collapse-" +
                                                                                              log.id,
                                                                                            "aria-controls":
                                                                                              "#collapse-" +
                                                                                              log.id
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _vm._m(
                                                                                            73,
                                                                                            true
                                                                                          ),
                                                                                          _vm._v(
                                                                                            " "
                                                                                          ),
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "log-description"
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "p",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "mb-0 log-description"
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        "Locations note updated"
                                                                                                      )
                                                                                                    ]
                                                                                                  ),
                                                                                                  _vm._v(
                                                                                                    " "
                                                                                                  ),
                                                                                                  _c(
                                                                                                    "p",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "mb-0 log-date"
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._v(
                                                                                                        _vm._s(
                                                                                                          log.created_at
                                                                                                        ) +
                                                                                                          " | " +
                                                                                                          _vm._s(
                                                                                                            log.done_by
                                                                                                          )
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _vm._m(
                                                                                                74,
                                                                                                true
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _vm._v(
                                                                                        " "
                                                                                      ),
                                                                                      _c(
                                                                                        "div",
                                                                                        {
                                                                                          staticClass:
                                                                                            "collapse",
                                                                                          attrs: {
                                                                                            id:
                                                                                              "collapse-" +
                                                                                              log.id,
                                                                                            "aria-expanded":
                                                                                              "false",
                                                                                            "aria-labelledby":
                                                                                              "heading-" +
                                                                                              log.id,
                                                                                            "data-parent":
                                                                                              "#accordion"
                                                                                          }
                                                                                        },
                                                                                        [
                                                                                          _c(
                                                                                            "div",
                                                                                            {
                                                                                              staticClass:
                                                                                                "row"
                                                                                            },
                                                                                            [
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                                                }
                                                                                              ),
                                                                                              _vm._v(
                                                                                                " "
                                                                                              ),
                                                                                              _c(
                                                                                                "div",
                                                                                                {
                                                                                                  staticClass:
                                                                                                    "col-11 pt-3"
                                                                                                },
                                                                                                [
                                                                                                  _c(
                                                                                                    "table",
                                                                                                    {
                                                                                                      staticClass:
                                                                                                        "table m-table table-hover log-table"
                                                                                                    },
                                                                                                    [
                                                                                                      _vm._m(
                                                                                                        75,
                                                                                                        true
                                                                                                      ),
                                                                                                      _vm._v(
                                                                                                        " "
                                                                                                      ),
                                                                                                      _c(
                                                                                                        "tbody",
                                                                                                        [
                                                                                                          log
                                                                                                            .data
                                                                                                            .old_value ||
                                                                                                          log
                                                                                                            .data
                                                                                                            .new_value
                                                                                                            ? _c(
                                                                                                                "tr",
                                                                                                                [
                                                                                                                  _c(
                                                                                                                    "td",
                                                                                                                    [
                                                                                                                      _vm._v(
                                                                                                                        "Note:"
                                                                                                                      )
                                                                                                                    ]
                                                                                                                  ),
                                                                                                                  _vm._v(
                                                                                                                    " "
                                                                                                                  ),
                                                                                                                  _c(
                                                                                                                    "td",
                                                                                                                    [
                                                                                                                      _vm._v(
                                                                                                                        _vm._s(
                                                                                                                          log
                                                                                                                            .data
                                                                                                                            .old_value
                                                                                                                        )
                                                                                                                      )
                                                                                                                    ]
                                                                                                                  ),
                                                                                                                  _vm._v(
                                                                                                                    " "
                                                                                                                  ),
                                                                                                                  _c(
                                                                                                                    "td",
                                                                                                                    [
                                                                                                                      _vm._v(
                                                                                                                        _vm._s(
                                                                                                                          log
                                                                                                                            .data
                                                                                                                            .new_value
                                                                                                                        )
                                                                                                                      )
                                                                                                                    ]
                                                                                                                  )
                                                                                                                ]
                                                                                                              )
                                                                                                            : _vm._e()
                                                                                                        ]
                                                                                                      )
                                                                                                    ]
                                                                                                  )
                                                                                                ]
                                                                                              )
                                                                                            ]
                                                                                          )
                                                                                        ]
                                                                                      )
                                                                                    ]
                                                                                  : log.type ===
                                                                                      "job_file_uploaded" ||
                                                                                    log.type ===
                                                                                      "job_file_updated" ||
                                                                                    log.type ===
                                                                                      "job_file_deleted"
                                                                                    ? [
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "row align-items-center log-box collapsed",
                                                                                            attrs: {
                                                                                              id:
                                                                                                "heading-" +
                                                                                                log.id,
                                                                                              "data-toggle":
                                                                                                "collapse",
                                                                                              "data-parent":
                                                                                                "#accordion",
                                                                                              "data-target":
                                                                                                "#collapse-" +
                                                                                                log.id,
                                                                                              "aria-controls":
                                                                                                "#collapse-" +
                                                                                                log.id
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _vm._m(
                                                                                              76,
                                                                                              true
                                                                                            ),
                                                                                            _vm._v(
                                                                                              " "
                                                                                            ),
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "col-11 d-flex align-items-center justify-content-between flex-row"
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "div",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "log-description"
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "p",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "mb-0 log-description"
                                                                                                      },
                                                                                                      [
                                                                                                        log.type ===
                                                                                                        "job_file_uploaded"
                                                                                                          ? [
                                                                                                              _vm._v(
                                                                                                                "\n                      File uploaded\n                    "
                                                                                                              )
                                                                                                            ]
                                                                                                          : log.type ===
                                                                                                            "job_file_updated"
                                                                                                            ? [
                                                                                                                _vm._v(
                                                                                                                  "\n                      File updated\n                    "
                                                                                                                )
                                                                                                              ]
                                                                                                            : [
                                                                                                                _vm._v(
                                                                                                                  "\n                      File deleted\n                    "
                                                                                                                )
                                                                                                              ]
                                                                                                      ],
                                                                                                      2
                                                                                                    ),
                                                                                                    _vm._v(
                                                                                                      " "
                                                                                                    ),
                                                                                                    _c(
                                                                                                      "p",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "mb-0 log-date"
                                                                                                      },
                                                                                                      [
                                                                                                        _vm._v(
                                                                                                          _vm._s(
                                                                                                            log.created_at
                                                                                                          ) +
                                                                                                            " | " +
                                                                                                            _vm._s(
                                                                                                              log.done_by
                                                                                                            )
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  ]
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                _vm._m(
                                                                                                  77,
                                                                                                  true
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        ),
                                                                                        _vm._v(
                                                                                          " "
                                                                                        ),
                                                                                        _c(
                                                                                          "div",
                                                                                          {
                                                                                            staticClass:
                                                                                              "collapse",
                                                                                            attrs: {
                                                                                              id:
                                                                                                "collapse-" +
                                                                                                log.id,
                                                                                              "aria-expanded":
                                                                                                "false",
                                                                                              "aria-labelledby":
                                                                                                "heading-" +
                                                                                                log.id,
                                                                                              "data-parent":
                                                                                                "#accordion"
                                                                                            }
                                                                                          },
                                                                                          [
                                                                                            _c(
                                                                                              "div",
                                                                                              {
                                                                                                staticClass:
                                                                                                  "row"
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "div",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "col-1 d-none d-lg-block d-xl-block d-md-block"
                                                                                                  }
                                                                                                ),
                                                                                                _vm._v(
                                                                                                  " "
                                                                                                ),
                                                                                                _c(
                                                                                                  "div",
                                                                                                  {
                                                                                                    staticClass:
                                                                                                      "col-11 pt-3"
                                                                                                  },
                                                                                                  [
                                                                                                    _c(
                                                                                                      "table",
                                                                                                      {
                                                                                                        staticClass:
                                                                                                          "table m-table table-hover log-table"
                                                                                                      },
                                                                                                      [
                                                                                                        _c(
                                                                                                          "tbody",
                                                                                                          [
                                                                                                            _c(
                                                                                                              "tr",
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "td",
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      "File name:"
                                                                                                                    )
                                                                                                                  ]
                                                                                                                ),
                                                                                                                _vm._v(
                                                                                                                  " "
                                                                                                                ),
                                                                                                                _c(
                                                                                                                  "td",
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      _vm._s(
                                                                                                                        log
                                                                                                                          .data
                                                                                                                          .name
                                                                                                                      )
                                                                                                                    )
                                                                                                                  ]
                                                                                                                )
                                                                                                              ]
                                                                                                            ),
                                                                                                            _vm._v(
                                                                                                              " "
                                                                                                            ),
                                                                                                            _c(
                                                                                                              "tr",
                                                                                                              [
                                                                                                                _c(
                                                                                                                  "td",
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      "Visible to customer:"
                                                                                                                    )
                                                                                                                  ]
                                                                                                                ),
                                                                                                                _vm._v(
                                                                                                                  " "
                                                                                                                ),
                                                                                                                _c(
                                                                                                                  "td",
                                                                                                                  [
                                                                                                                    _vm._v(
                                                                                                                      _vm._s(
                                                                                                                        log
                                                                                                                          .data
                                                                                                                          .can_see_customer ||
                                                                                                                        log
                                                                                                                          .data
                                                                                                                          .uploaded_by_customer
                                                                                                                          ? "Yes"
                                                                                                                          : "No"
                                                                                                                      )
                                                                                                                    )
                                                                                                                  ]
                                                                                                                )
                                                                                                              ]
                                                                                                            )
                                                                                                          ]
                                                                                                        )
                                                                                                      ]
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          ]
                                                                                        )
                                                                                      ]
                                                                                    : _vm._e()
                    ],
                    2
                  )
                })
              )
            ]
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Old value:")]),
        _vm._v(" "),
        _c("th", [_vm._v("New value:")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block"
      },
      [_c("i", { staticClass: "fa fa-circle-thin" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", {}, [
      _c("span", { staticClass: "mod-icon-plus" }),
      _vm._v(" "),
      _c("span", { staticClass: "mod-icon-minus" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20e7a8c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20e7a8c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/JobLogs.vue
// module id = null
// module chunks = 